import { Fragment, memo, useEffect, useState } from 'react';
import { IChartData, IData, IDataChange } from 'interfaces/demographics';
import ModalInstance from './Component/ModalInstance';
import ModalChangeDataTable from './Component/ModalChangeDataTable';

interface ModalsChartDataTableProps {
  chartsData: IChartData[];
  yearRangeViewStep: number[];
  yearRange: [number, number];
  onSubmit: (data: IDataChange) => void;
  onPopChart: (topicId: number, variableId: number) => void;
  baseYear?: number;
}
export interface IModalChartItem {
  chartData: IChartData;
  coordinate: [number, number];
  position?: { x: number; y: number };
}
const ModalChartDataTableNew = memo(({ chartsData, yearRangeViewStep, yearRange,baseYear, onSubmit, onPopChart }: ModalsChartDataTableProps) => {
  const [modalChartItems, setModalChartItems] = useState<IModalChartItem[]>([]);
  const [changeChartItem, setChangeChartItem] = useState<IModalChartItem>(null);
  useEffect(() => {
    setModalChartItems(
      chartsData?.map((chartData) => ({
        topicId: chartData?.baseCaseData?.topicId,
        variableId: chartData?.baseCaseData?.variableId,
        chartData: {
          baseCaseData: chartData?.baseCaseData,
          revisedData: chartData?.revisedData,
          forecastYear: chartData?.forecastYear,
        },
        coordinate: [(modalChartItems.length + 1) * 20, (modalChartItems.length + 1) * 20],
        position: { x: (modalChartItems.length + 1) * 20, y: (modalChartItems.length + 1) * 20 },
      }))
    );
  }, [chartsData]);

  const onOpenModal = (variableId: number) => {
    const chart = modalChartItems?.find((item) => item?.chartData?.baseCaseData?.variableId === variableId);
    if (chart) {
      setChangeChartItem(chart);
    }
  };
  const onCloseModal = () => {
    setChangeChartItem(null);
  };

  const _onSubmit = (data: IData) => {
    onSubmit({
      topicId: changeChartItem?.chartData?.baseCaseData.topicId,
      variableId: changeChartItem?.chartData?.baseCaseData?.variableId,
      reversedDataChanged: data,
    });
    onCloseModal();
  };
  return (
    <Fragment>
      {modalChartItems?.map((chartItem, index) => (
        <ModalInstance
          key={index}
          defaultPosition={chartItem.position}
          id={index}
          onClose={() => {
            onPopChart(chartItem?.chartData?.baseCaseData?.topicId, chartItem?.chartData?.baseCaseData?.variableId);
          }}
          onChange={() => {
            onOpenModal(chartItem?.chartData?.baseCaseData?.variableId);
          }}
          chartItem={chartItem}
          changeChartItem={changeChartItem}
          yearRange={yearRange}
          baseYear={baseYear}
        />
      ))}
      {changeChartItem ? (
        <ModalChangeDataTable
          isOpen={!!changeChartItem}
          data={{
            chartData: changeChartItem?.chartData,
            yearRange: yearRange,
            yearRangeViewStep: yearRangeViewStep,
          }}
          onClose={onCloseModal}
          onSubmit={_onSubmit}
        />
      ) : null}
    </Fragment>
  );
});

export default ModalChartDataTableNew;
